import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { CrudService } from 'app/shared/services/crud.service';
import { DataTableBasicComponent } from 'app/shared/components/data-table/data-table-basic.component';
import { Grupo } from 'app/cadastro/model/grupo.model';
import { HttpService } from 'app/shared/services/http.service';
import { SessionService } from 'app/shared/services/session.service';
import { DblinkedSessionService } from 'app/shared/services/dblinked-session.service';
import { ConfigService } from 'app/shared/services/config.service';
import { UtilService } from 'app/shared/services/util.service';
import { MessageService } from 'primeng/api';
import { SelectItem } from 'app/shared/common/select-item.interface';
import { Toolbar } from 'app/shared/model/toolbar.model';
import { ToolbarService } from 'app/shared/services/toolbar.service';

@Component({
  selector: 'app-grupo',
  templateUrl: './grupo.component.html',
  styleUrls: ['./grupo.component.scss'],
  providers: [CrudService]
})
export class GrupoComponent extends DataTableBasicComponent implements OnInit, OnDestroy {
  public grupo: Grupo = new Grupo();
  public registroGrupo: Array<Grupo> = new Array();

  ids: Array<any> = new Array();

  //Boolean
  ctrlSave: boolean;
  editarConta: boolean;
  novaConta: boolean;

  //String
  descGrupo: string;
  parentAlmo: string;
  block: boolean;


  opcoesGrupo: SelectItem[] =  [{label: 'Todos', value: ''}, { label: 'SIm', value: true }, { label: 'Não', value: false }];

  title = 'GRUPO';
  subtitle = " GRUPO";

  public empresaSelecionada: number;
  private empresaSubscription: Subscription;
  private sessionSubscription: Subscription;
  private beforeSaveSubscription: Subscription;
  private beforeEditSubscription: Subscription;

  constructor(private crudService: CrudService,
    private httpService: HttpService,
    private toolbarService: ToolbarService,
    private sessionService: SessionService,
    private dblinkedSessionService: DblinkedSessionService,
    private messageService: MessageService,
    private configService: ConfigService,
    private utilService: UtilService) {
    super(crudService);
  }

  public toolbarMain = new Toolbar()

  toolbarMainIni = [
    { icon: 'navigate_before', text: 'Voltar', tooltip: 'Voltar', visible: false, disabled: false, color: 'default', onClick: () => this.carregar() },
    { icon: 'edit', text: 'Editar', tooltip: 'Editar', visible: false, disabled: false, color: 'default', onClick: () => this.loadEditarRegistro() },
    { icon: 'delete', text: 'Remover', tooltip: 'Remover', visible: false, disabled: false, color: 'default', onClick: () => this.excluirRegistro() },
    { icon: 'add', text: 'Novo', tooltip: 'Novo', visible: false, disabled: false, color: 'default', onClick: () => this.criarNovo() },
    { icon: 'save', text: 'Salvar', tooltip: 'Salvar Novo Registro', visible: false, disabled: false, color: 'default', onClick: () => this.salvarNovoRegistro() },
    { icon: 'save', text: 'Salvar', tooltip: 'Salvar Alteração de Registro', visible: false, disabled: false, color: 'default', onClick: () => this.salvarAlteracaoRegistro() },
  ]

  ngOnInit() {
    this.toolbarMain.setAll(this.toolbarMainIni)
    this.toolbarService.hidden = true
    this.sessionSubscription = this.sessionService.initSubscribe(
      this.dblinkedSessionService.sessionChanged,
      () => this.carregar()
    );
  }

  carregar(){
    this.title = 'GRUPO';
    this.subtitle = 'GRUPO';
    this.novaConta = false;
    this.editarConta = false;
    this.ids = new Array();

    this.limpaCamposForm();
    this.loadRegistros();

    this.toolbarMain.setVisible('btn1', false)
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', false)
    this.toolbarMain.setVisible('btn4', true)
    this.toolbarMain.setVisible('btn5', false)
    this.toolbarMain.setVisible('btn6', false)
  }

  selectCheckboxContainer(data){
    setTimeout(() => {
      document.getElementById('checkboxContainer'+data.id).click();
    },100);
  };

  criarNovo() {
    this.novaConta = true;
    this.title = 'Cadastrar Grupo';

    this.toolbarMain.setVisible('btn1', true)
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', false)
    this.toolbarMain.setVisible('btn4', false)
    this.toolbarMain.setVisible('btn5', true)
    this.toolbarMain.setVisible('btn6', false)
  }

  loadRegistros(){
    this.httpService.wait();
    this.httpService
    .get(`/grupo?$select=descricao,bloqueiaApuracao&$orderby=descricao`)
    .subscribe(
      (retorno) => {
          this.registroGrupo = new Array();
          retorno.value.forEach(item => {
            this.registroGrupo.push(item);
          })
        },
        error => this.httpService.handleError(error, () => this.carregar()),
        () => this.httpService.done()
      );
  }

  loadEditarRegistro() {
    this.title = 'Editar Grupo';
    this.editarConta = true;

    this.toolbarMain.setVisible('btn1', true)
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', true)
    this.toolbarMain.setVisible('btn4', false)
    this.toolbarMain.setVisible('btn5', false)
    this.toolbarMain.setVisible('btn6', true)

    this.limpaCamposForm();

    this.httpService.get(`/grupo(${this.ids[0]})?$select=descricao,bloqueiaApuracao&$count=true`)
      .subscribe(item => {
        this.descGrupo = item.value.descricao;
        this.block = item.value.bloqueiaApuracao;
        this.parentAlmo = item.value.parent.id;
      },
      error => this.httpService.handleError(error, () => this.carregar()),
      () => this.httpService.done());
  }

  salvarNovoRegistro() {
    if (this.validacao()) {
      return;
    }

    const jsonData = {
      descricao: this.descGrupo,
      empresa: {
        id: this.dblinkedSessionService.empresa.id
      },
      parent: {
        id: this.parentAlmo

      },
      bloqueiaApuracao: this.block
    };

    this.httpService.post('/grupo', jsonData)
      .subscribe(result => {

        if (!(result === null || result === undefined)) {
            this.messageService.add({
              severity: 'success', key: 'messageLinnks', summary: 'Sucesso  ', detail: 'Registro cadastrado com sucesso!'
            });
            this.carregar();
        }else{
            this.messageService.add({
              severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Falha no cadastro. Tente novamente'
            });
            this.carregar();
            return;
        }
      }, error => this.httpService.handleError(error, () =>  this.salvarNovoRegistro()),
      () => this.httpService.done());
  }

  salvarAlteracaoRegistro() {
    if (this.validacao()) {
      return;
    }

    const jsonData = {
      descricao: this.descGrupo,
      parent: {
        id: this.parentAlmo
      },
      bloqueiaApuracao: this.block
    };

    let key = this.ids[0];

    this.httpService.wait();
    this.httpService.patch('/grupo', key, jsonData, null)
      .subscribe(result => {
        if (result === null) {
          this.messageService.add({
            severity: 'success', key: 'messageLinnks', summary: 'Sucesso  ', detail: 'Registro alterado com sucesso!'
          });
          this.carregar();
        } else {
          this.messageService.add({
            severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Falha na alteração do registro!'
          });
          this.carregar();
          return;
        }
      },
      error => this.httpService.handleError(error, () => this.salvarAlteracaoRegistro()),
      () => this.httpService.done());
  }

  excluirRegistro() {
    if (confirm('Deseja deletar os registros selecionados? ')) {
      this.httpService.wait();
      this.httpService.delete('/grupo', this.ids)
        .subscribe(result => {
          if (result === null) {
            this.messageService.add({
              severity: 'success', key: 'messageLinnks',
              summary: '',
              detail: 'Registro excluído com sucesso!'
            });
            this.carregar();
            this.ids = [];
          } else {
            this.messageService.add({
              severity: 'warn', key: 'messageLinnks',
              summary: '',
              detail: 'Falha na exclusão. Tente novamente!'
            });
          }
        },
        error => this.httpService.handleError(error, () => this.carregar()),
        () => this.httpService.done());
    }
  }

  ngOnDestroy() {
    this.sessionService.destroySubscribe(this.empresaSubscription);
    this.sessionService.destroySubscribe(this.beforeSaveSubscription);
  }

  selectCheckbox(event: any){
    this.ids.push(event.data.id);
    event.selected = false;
    this.changeToolbar();
  }

  unselectCheckbox(event: any){
    const index = this.ids.findIndex(c => c === event.data.id);
    this.ids.splice(index, 1);
    event.selected = true;
    this.changeToolbarUn();
  }

  changeToolbar() {
    this.toolbarMain.setVisible('btn2', true)
    this.toolbarMain.setVisible('btn3', true)
  }

  changeToolbarUn(){
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', false)
  }


  validacao(): boolean {
    if ((this.descGrupo === null || this.descGrupo === undefined) || this.descGrupo.trim().length < 1) {
      this.messageService.add({ severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Descrição é Obrigatório' });
      return true;
    }
    return false;
  }

  private limpaCamposForm(){
    this.descGrupo = '';
    this.block = false;
    this.parentAlmo = '';
  }

  get hasEmpresaSelected(): boolean {
    return this.dblinkedSessionService.hasEmpresaSelected;
  }
  get loading(): boolean {
    return this.httpService.loading;
  }
  get rowsPerPage() {
    return this.configService.applicationConfig.rowsPerPage;
  }
  get rows() {
    return this.configService.applicationConfig.rows;
  }
  get pageLinks() {
    return this.configService.applicationConfig.pageLinks;
  }
}
